import { Navigate } from 'react-router-dom';

import { useProfile } from 'context/profile';
import { Accessor } from 'models/Profile';

type ProtectedRouteProps = {
  children: React.ReactNode;
  accessor?: Accessor | Accessor[];
  strictMode?: boolean;
  deny?: boolean;
};

const ProtectedRoute = ({ children, accessor, strictMode = true, deny = false }: ProtectedRouteProps) => {
  const { profile } = useProfile();

  if (deny) {
    return <Navigate to='/patients' replace />;
  }

  if (accessor) {
    const accessors = Array.isArray(accessor) ? accessor : [accessor];
    const isAccessGranted = strictMode ? profile.hasAll(accessors) : profile?.hasAny(accessors);

    if (!isAccessGranted) {
      return <Navigate to='/patients' replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
